<template>
    <div id="albums">
        <template v-if="items">
            <div id="albums-albums" class="row" v-if="items.length">
                <div :id="`albums-item-${i + 1}`" :class="`col-md-${col}`" v-for="(item, i) in items" :key="i">
                    <div class="bk-card-wrap">
                        <a href="#"
                           @click.prevent="$router.push(i18nLink(`album/gallery/${item.id}`))"
                           class="bk-card">
                            <span class="bk-card-img"
                                  :style="getThumbnail(item) ? `background-image: url(${getThumbnail(item)})`: ''">
                                <img v-if="!getThumbnail(item)" :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview.jpg`)" :alt="item.title">
                            </span>
                            <span class="bk-card-body bk-card-body--icon">
                                <span class="bk-card-title d-block">{{ item.title ? item.title : $t('no_name') }}</span>
                                <span class="bk-card-text d-block">
                                    {{ $tc('n_photos_2', item.total_pictures || 0, {amount_total_photos: item.total_pictures || 0}) }}
                                </span>
                            </span>
                        </a>
                        <socials :url="i18nLink(`album/gallery/${item.id}`)"/>
                    </div>
                </div>
            </div>
            <div v-else class="alert alert-info">{{ $t('no_data') }}</div>
        </template>
        <card-skeleton :cols="col" :amount="5" :share-icon="true" v-else/>
        <back-button v-if="showBackButton" :url="prevUrl"/>
    </div>
</template>

<script>
  import CardSkeleton from './skeleton/Cards.vue';
  import BackButton from './BackButton.vue';
  import Socials from './Socials.vue';

  import albums from 'src/mixins/albumsComponent';

  export default {
    mixins: [albums],
    components: {
      CardSkeleton,
      BackButton,
      Socials,
    },
  };
</script>

